import { guestNeedsOnboarding } from './subscriptionGate';

export const ONBOARDING_QUERY = 'onboarding';
export const ONBOARDING_FROM = 'from';

/** Orden: marca en PDF → cliente → venta → cobro → gasto opcional. */
export const ONBOARDING_STEPS = [
  {
    id: 'branding',
    step: 1,
    label: 'Logo y comprobante PDF',
    hint: 'Subí tu logo para recordatorios y emails',
    href: '/cuenta?tab=profile&from=onboarding#comprobante-pdf',
  },
  {
    id: 'client',
    step: 2,
    label: 'Agregar cliente',
    hint: 'Guardá sus datos de contacto',
    href: '/clientes?tab=crear&from=onboarding',
  },
  {
    id: 'sale',
    step: 3,
    label: 'Registrar venta',
    hint: 'Dejala impaga si todavía no cobraste',
    href: '/facturas?tab=crear&modo=rapido&from=onboarding',
  },
  {
    id: 'collection',
    step: 4,
    label: 'Ver quién te debe',
    hint: 'Abrí Cobrar y priorizá impagas',
    href: '/cobranzas?from=onboarding',
  },
  {
    id: 'expense',
    step: 5,
    label: 'Anotar gasto',
    hint: 'Opcional: cierra el circuito del mes',
    href: '/egresos?tab=cargar&from=onboarding',
  },
];

export function isBrandingStepComplete(stats = {}) {
  if (stats.branding === true) return true;
  const company = stats.company || {};
  const logo = String(company.logo || '').trim();
  if (/^data:image\//i.test(logo)) return true;
  const name = String(company.name || '').trim();
  if (!name) return false;
  return Boolean(
    String(company.phone || '').trim()
    || String(company.email || '').trim()
    || String(company.address || '').trim()
  );
}

export function getOnboardingProgress(stats = {}) {
  const pendientes = Number(stats.pendientes) || 0;
  const collection = Boolean(stats.collection) || pendientes > 0;
  const branding = stats.branding === true || isBrandingStepComplete(stats);
  return {
    branding,
    client: (stats.clientes || 0) > 0,
    sale: (stats.facturas || 0) > 0,
    expense: (stats.egresos || 0) > 0,
    collection,
  };
}

/** Activación tesis (cliente + venta + gasto en 7 días). */
export function isCoreOnboardingComplete(progress) {
  return progress.client && progress.sale && progress.expense;
}

/** Circuito completo de los cinco pasos. */
export function isOnboardingComplete(progress) {
  return Boolean(
    progress.branding
    && isCoreOnboardingComplete(progress)
    && progress.collection,
  );
}

/** C10.3: tiempo al valor — cliente, venta y cobro visible o gestionado. */
export function isActivationComplete(progress) {
  return Boolean(progress?.client && progress?.sale && progress?.collection);
}

export function getCurrentStepId(progress) {
  if (!progress.branding) return 'branding';
  if (!progress.client) return 'client';
  if (!progress.sale) return 'sale';
  if (!progress.collection) return 'collection';
  if (!progress.expense) return 'expense';
  return null;
}

export function getCompletedStepCount(progress) {
  return ONBOARDING_STEPS.filter((step) => progress[step.id]).length;
}

export function getNextStepAfter(stepId) {
  const index = ONBOARDING_STEPS.findIndex((step) => step.id === stepId);
  if (index < 0 || index >= ONBOARDING_STEPS.length - 1) return null;
  return ONBOARDING_STEPS[index + 1];
}

export function isFromOnboarding(search = '') {
  const params = new URLSearchParams(search);
  return params.get(ONBOARDING_FROM) === 'onboarding';
}

export function inicioOnboardingPath() {
  return `/inicio?${ONBOARDING_QUERY}=1`;
}

/** Tras pago aprobado: perfil pendiente → completar; cuenta nueva → inicio con checklist. */
export function resolvePostPaymentDestination(user, { newSignup = false } = {}) {
  if (!user) {
    return newSignup ? inicioOnboardingPath() : '/inicio';
  }
  if (guestNeedsOnboarding(user)) return '/completar-perfil';
  if (newSignup) return inicioOnboardingPath();
  return '/inicio';
}
